import { IStandardApiError } from "../api/base/i-standard-api-error.js";
import { IExtendedApiError } from "../api/base/i-extended-api-error.js";
import { ExtendedApiError } from "../api/base/extended-api-error.js";
import { Notify } from "./notify.js";

export function notifyAndThrowExtendedApiError(error: IExtendedApiError) {
    const notify = new Notify();
    notify.error(error.errorMessage);
    throw new ExtendedApiError(error);
}

export function notifyAndLogStandardApiError(error: IStandardApiError) {
    const notify = new Notify();
    notify.error(`${error.message}`);
    console.error(`${error.message} Details: ${error.exceptionType}. ${error.exceptionMessage}.`);
}

export function notifyExtendedApiError(error: IExtendedApiError) {
    const notify = new Notify();
    notify.error(`${error.errorMessage}`);    
}

export function logExtendedApiError(error: IExtendedApiError) {
    console.error(`${error.devErrorMessage ? error.devErrorMessage : error.errorMessage}`);
}

export function logStandardApiError(error: IStandardApiError) {
    console.error(`${error.message} Details: ${error.exceptionType}. ${error.exceptionMessage}.`);
}

export function standardToExtendedApiReporter(standardErrorReporter: (error: IStandardApiError) => void): (error: IExtendedApiError) => void{
    return (error: IExtendedApiError) => {
        const errorDetails = {
            message: error.errorMessage,
            exceptionMessage: error.devErrorMessage,
            stackTrace: error.devStackTrace
        } as IStandardApiError;

        standardErrorReporter(errorDetails);
    }
}
